import type { AppThunk } from 'state';
import DataServiceDataCities from 'common/dataService/services/dataCities';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import { setCountryCode, setDataCities, setFetching } from '../slice';

function fetchDataCities(countryCode: string): AppThunk {
  return async function fetchDataCitiesThunk(dispatch, getState) {
    try {
      const { fetching, countryCode: currentCountryCode } = getState().dataService.dataCities;

      if (fetching === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setFetching(FetchingStatus.InProgress));
      dispatch(setCountryCode(countryCode));
      if (currentCountryCode !== countryCode) {
        dispatch(setDataCities([]));
      }

      const data = await DataServiceDataCities.getDataCities(countryCode);

      if (!data) {
        dispatch(setFetching(FetchingStatus.Failed));
        return;
      }

      dispatch(setDataCities(data));
      dispatch(setFetching(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(setFetching(FetchingStatus.Failed));
      window.Rollbar.error(error as Error);
    }
  };
}

export default fetchDataCities;
